/**
 * Notification Settings API Contract
 *
 * Mirrors: backend/src/routes/notificationSettings.routes.ts
 * 1:1 parity with existing Express routes
 */
import { oc } from "@orpc/contract";
import { z } from "zod";
import { GetNotificationSettingsQuerySchema, UpdateMasterToggleInputSchema, UpdateSettingParamsSchema, UpdateSettingInputSchema, NotificationSettingResponseSchema, NotificationSettingsResponseSchema, MasterToggleResponseSchema, } from "@hourly/api/notificationSettings";
// ============================================
// Notification Settings Contracts
// ============================================
/**
 * GET /api/user-profile/notification-settings
 * Get all notification settings for the current user
 */
export const getNotificationSettings = oc
    .route({
    method: "GET",
    path: "/notification-settings",
    summary: "Get all notification settings for the current user",
    tags: ["Notification Settings"],
    inputStructure: "detailed",
})
    .input(z.object({
    query: GetNotificationSettingsQuerySchema,
}))
    .output(NotificationSettingsResponseSchema);
/**
 * PATCH /api/user-profile/notification-settings/master
 * Toggle all notifications on/off (master toggle)
 */
export const updateMasterToggle = oc
    .route({
    method: "PATCH",
    path: "/notification-settings/master",
    summary: "Toggle all notifications on/off",
    tags: ["Notification Settings"],
    inputStructure: "detailed",
})
    .input(z.object({
    query: GetNotificationSettingsQuerySchema,
    body: UpdateMasterToggleInputSchema,
}))
    .output(MasterToggleResponseSchema);
/**
 * PATCH /api/user-profile/notification-settings/{categoryId}/{settingId}
 * Update a specific notification setting
 */
export const updateNotificationSetting = oc
    .route({
    method: "PATCH",
    path: "/notification-settings/{categoryId}/{settingId}",
    summary: "Update a specific notification setting",
    tags: ["Notification Settings"],
    inputStructure: "detailed",
})
    .input(z.object({
    params: UpdateSettingParamsSchema,
    query: GetNotificationSettingsQuerySchema,
    body: UpdateSettingInputSchema,
}))
    .output(NotificationSettingResponseSchema);
// ============================================
// Contract Router
// ============================================
export const notificationSettingsContract = {
    get: getNotificationSettings,
    updateMaster: updateMasterToggle,
    updateSetting: updateNotificationSetting,
};
//# sourceMappingURL=notificationSettings.js.map